import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { openLink } from '@tma.js/sdk-react';

import type { ContentBlock } from '@/types/newsService';

interface Props {
  block: ContentBlock;
}

export const EmbedBlock = memo(function EmbedBlock({ block }: Props) {
  const { t } = useTranslation('news');
  if (!block.embedUrl) return null;

  const handleClick = () => {
    // openLink routes through Telegram's system-browser handler when inside
    // the WebView; falls through to `window.open` otherwise.
    const opened = openLink.ifAvailable(block.embedUrl!);
    if (!opened) window.open(block.embedUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="my-3 block w-full rounded-xl border border-border bg-bg-secondary p-4 text-left transition-opacity active:opacity-80"
    >
      <span className="block text-[11px] font-bold uppercase text-brand">
        {block.embedType ?? t('embed.link')}
      </span>
      <span className="mt-1 line-clamp-2 block text-sm leading-5 text-fg">
        {block.embedUrl}
      </span>
      {block.caption ? (
        <span className="mt-1.5 block text-xs text-fg-muted">{block.caption}</span>
      ) : null}
    </button>
  );
});
